import { render, staticRenderFns } from "./AreaUpload.vue?vue&type=template&id=5b6154e3&scoped=true"
import script from "./AreaUpload.vue?vue&type=script&lang=js"
export * from "./AreaUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6154e3",
  null
  
)

export default component.exports